module.exports = __webpack_public_path__ + "img/Einheit_der_Polizei.5cf02a1c.svg";